/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React, { Fragment, useCallback, useEffect, useState } from "react";
// styles
import "./style.scss";
// internal components
import {
  navLinkUsers,
  navLinkAgent,
  navLinkSupplier,
  navLinkbusinessDev,
  navLinkSuperAdmin,
  navLinkGrainManager,
  navLinkAreaManager,
  navLinkCog,
  commonNavLink,
  navLinkBusinessHead,
  navLinkClusterManager,
  navLinkZonalManager,
  navLinkGrainDepositor,
  navLinkCogOnboarding,
  navLinkContractUsers,
  navLinkQualityManager,
  navLinkFinanceTeamMember,
} from "../../../helpers/RoleAccessData/index";
// images and svg
// import logo from "../../../assets/images/digigrainLogo.svg";
import logo from "../../../assets/images/digi360.png";

// services
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import { NavLink } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import Collapse from "@material-ui/core/Collapse";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useLocation } from "react-router-dom";
import { Toast } from "../../../service/toast";
// helpers
import { logout } from "service/utilities";
import { MdLogout } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { history } from "helpers";
import { setShowNavbar, updatePageData } from "redux/reducer/homeSlice";
import { getProfile } from "service/customer";

function Sidebar({ privilegesData, classes }) {
  const dispatch = useDispatch();

  const Selectedrole = useSelector((state) => state.home.role);
  const ShowNavBar = useSelector((state) => state.home.navbarshow);
  const profileId = useSelector((state) => state?.home?.userDetails?.profileId);

  const theme = useTheme();
  const [navLink, setNavLink] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [active, setActive] = useState(0);
  const [activeTernery, setActiveTernery] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const location = useLocation();
  const [isContract, setIsContract] = useState(null);

  useEffect(() => {
    assignRouters();
    getProfileDetails();
  }, [Selectedrole, isContract]);

  const handleSideBarUpdate = useCallback(() => {
    const payloadData = {
      reduxPage: 1,
      numberOfList: 1,
    };
    dispatch(updatePageData(payloadData));
    getProfileDetails();
  }, []);

  const getProfileDetails = async () => {
    let params = {
      profileId: profileId,
    };
    const response = await getProfile(params);
    if (response?.status === 200) {
      setIsContract(response?.data?.data?.contractDone);
    }
  };

  useEffect(() => {
    // getProfileDetails();
  }, []);

  const assignRouters = async () => {
    await setNavLink([]);
    let role = String(Selectedrole).toUpperCase();
    (await (navLinkUsers || navLinkContractUsers)) && role === "CUSTOMER"
      ? isContract
        ? setNavLink(navLinkUsers)
        : setNavLink(navLinkContractUsers)
      : navLinkAgent && role === "AGENT"
      ? setNavLink(navLinkAgent)
      : navLinkSupplier && role === "SUPPLIER"
      ? setNavLink(navLinkSupplier)
      : navLinkbusinessDev && role === "BDE"
      ? setNavLink(navLinkbusinessDev)
      : navLinkAreaManager && role === "AREA MANAGER"
      ? setNavLink(navLinkAreaManager)
      : navLinkGrainManager && role === "GRAIN MANAGER"
      ? setNavLink(navLinkGrainManager)
      : navLinkCog && role === "COG - COMMERCIAL TEAM - MEMBER" //COG - commercial team - member
      ? setNavLink(navLinkCog)
      : navLinkSuperAdmin && role === "SUPER ADMIN"
      ? setNavLink(navLinkSuperAdmin)
      : navLinkZonalManager && role === "ZONAL MANAGER"
      ? setNavLink(navLinkZonalManager)
      : navLinkBusinessHead && role === "BUSINESS HEAD"
      ? setNavLink(navLinkBusinessHead)
      : navLinkClusterManager && role === "CLUSTER MANAGER"
      ? setNavLink(navLinkClusterManager)
      : navLinkGrainDepositor && role === "GRAIN DEPOSITOR"
      ? setNavLink(navLinkGrainDepositor)
      : navLinkQualityManager && role === "QUALITY MANAGER"
      ? setNavLink(navLinkQualityManager)
      : navLinkCogOnboarding && role === "COG - ONBOARDING TEAM - MEMBER"
      ? setNavLink(navLinkCogOnboarding)
      : navLinkFinanceTeamMember && role === "FINANCE - TEAM MEMBER"
      ? setNavLink(navLinkFinanceTeamMember)
      : "";
  };

  const renderTerneryMenu = (ternaryNav) => {
    return ternaryNav
      .map(({ to, iconName, inactiveIcon, label, privilegesName }, index) => {
        const privilege = privilegesData?.[privilegesName];
        if (privilege && privilege?.view) {
          return (
            <>
              <NavLink
                key={`ternery-nav-${Math.random()}`}
                to={to ? to : location.pathname}
                style={{ textDecoration: "none" }}
                onClick={() => {setActiveTernery(index);dispatch(setShowNavbar(false))}}
              >
                <div
                  style={{
                    borderLeft:
                      location.pathname.startsWith(to) || !ternaryNav
                        ? //activeTernery === index
                          "8px solid #367BBF"
                        : "8px solid #ffffff",
                  }}
                >
                  <ListItem
                    button
                    className={
                      location.pathname.startsWith(to) || !ternaryNav
                        ? // activeTernery === index
                          "active-div"
                        : "inActive-div"
                    }
                  >
                    <ListItemText
                      className={
                        location.pathname.startsWith(to) || !ternaryNav
                          ? //activeTernery === index
                            "activeBar"
                          : "inActiveBar"
                      }
                    >
                      <div className="d-flex">
                        <span className="mr-4 ml-md-2">
                          {location.pathname.startsWith(to) || !ternaryNav ? (
                            <img src={iconName} alt="active-icon" className="sidebar_icon" />
                          ) : (
                            <img src={inactiveIcon} alt="inactive-icon" className="sidebar_icon" />
                          )}
                        </span>
                        <span
                          className={
                            location.pathname.startsWith(to) || !ternaryNav
                              ? //activeTernery === index
                                "activeBar"
                              : "inActiveBar"
                          }
                        >
                          {label}
                        </span>
                      </div>
                    </ListItemText>
                  </ListItem>
                </div>
              </NavLink>
            </>
          );
        }
        return null;
      })
      .filter(Boolean);
  };

  const renderSubMenu = (subNav, parentIndex) => {
    return subNav
      .map(
        (
          { to, iconName, inactiveIcon, label, privilegesName, ternaryNav },
          index
        ) => {
          const privilege = privilegesData?.[privilegesName];
          if (privilege && privilege?.view) {
            return (
              <>
                <NavLink
                  key={`sub-nav-${Math.random()}`}
                  to={to ? to : location?.pathname}
                  style={{ textDecoration: "none" }}
                  onClick={() => {
                    setSubIndex((prevIndex) =>
                      prevIndex === index ? -1 : index
                    );
                    setActive(index);
                    setActiveTernery(null);
                    handleSideBarUpdate();
                    dispatch(setShowNavbar(false))
                  }}
                >
                  <div
                    style={{
                      borderLeft:
                        location.pathname.startsWith(to) && !ternaryNav
                          ? //active === index && !ternaryNav
                            "8px solid #367BBF"
                          : "8px solid #ffffff",
                    }}
                  >
                    <ListItem
                      button
                      className={
                        location.pathname.startsWith(to) && !ternaryNav
                          ? //active === index && !ternaryNav
                            "active-div"
                          : "inActive-div"
                      }
                    >
                      <ListItemText
                        className={
                          location.pathname.startsWith(to) && !ternaryNav
                            ? //active === index && !ternaryNav
                              "activeBar"
                            : "inActiveBar"
                        }
                      >
                        <div className="d-flex">
                          <span className="mr-4 ml-md-2">
                            {location.pathname.startsWith(to) && !ternaryNav ? (
                              //index === active && !ternaryNav
                              <img src={iconName} alt="active-icon" className="sidebar_icon" />
                            ) : (
                              <img src={inactiveIcon} alt="inactive-icon" className="sidebar_icon" />
                            )}
                          </span>
                          <span
                            className={
                              location.pathname.startsWith(to) && !ternaryNav
                                ? //active === index && !ternaryNav
                                  "activeBar"
                                : "inActiveBar"
                            }
                          >
                            {label}
                          </span>
                        </div>
                      </ListItemText>
                      <span>
                        {subIndex !== index && ternaryNav ? (
                          <ExpandMoreIcon style={{ color: "#000000" }} />
                        ) : subIndex == index && ternaryNav ? (
                          <ExpandLessIcon style={{ color: "#000000" }} />
                        ) : null}
                      </span>
                    </ListItem>
                  </div>
                </NavLink>
                {subIndex === index && ternaryNav && (
                  <Collapse in={true} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {renderTerneryMenu(ternaryNav)}
                    </List>
                  </Collapse>
                )}
              </>
            );
          }
          return null;
        }
      )
      .filter(Boolean);
  };

  const drawer = (
    <div className="sidebardrawer-comp">
      <div className={classes.toolbar}>
        <div className="d-flex justify-content-center align-items-center">
          <div className="logo-padding">
            <img src={logo} alt="Digigrain_Logo" className="side_logo"></img>
          </div>
          <hr className="mx-1 mt-1" style={{ color: "text-muted" }} />
        </div>{" "}
      </div>

      <List className={classes.nav} style={{ textDecoration: "none" }}>
        {React.Children.toArray(
          navLink
            .map(
              (
                { to, label, iconName, inactiveIcon, subNav, privilegesName },
                index
              ) => {
                const privilege = privilegesData?.[privilegesName];
                if (privilege && privilege?.view) {
                  return (
                    <>
                      <NavLink
                        key={`nav-bar-${Math.random()}`}
                        to={to ? to : location.pathname}
                        onClick={() => {
                          setActiveIndex((prevIndex) =>
                            prevIndex === index ? -1 : index
                          );
                          setActive(null);
                          handleSideBarUpdate();
                          if(subNav && subNav?.length > 0){
                            dispatch(setShowNavbar(true))
                          }else{
                            dispatch(setShowNavbar(false))
                          }
                        }}
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          style={{
                            borderLeft:
                              location.pathname.startsWith(to) && !subNav
                                ? "8px solid #367BBF"
                                : "8px solid #ffffff",
                          }}
                        >
                          <ListItem
                            button
                            className={
                              location.pathname.startsWith(to) && !subNav
                                ? "active-div"
                                : "inActive-div"
                            }
                          >
                            <ListItemText>
                              <div className="d-flex">
                                <span className="mr-4 ml-md-2">
                                  {location.pathname.startsWith(to) &&
                                  !subNav ? (
                                    <img src={iconName} className="sidebar_icon" />
                                  ) : (
                                    <img src={inactiveIcon} className="sidebar_icon" />
                                  )}
                                </span>
                                <span
                                  className={
                                    location.pathname.startsWith(to) && !subNav
                                      ? "activeBar"
                                      : "inActiveBar"
                                  }
                                >
                                  {label}
                                </span>{" "}
                              </div>
                            </ListItemText>
                            <span>
                              {activeIndex !== index && subNav ? (
                                <ExpandMoreIcon style={{ color: "#000000" }} />
                              ) : activeIndex === index && subNav ? (
                                <ExpandLessIcon style={{ color: "#000000" }} />
                              ) : null}
                            </span>
                          </ListItem>
                        </div>
                      </NavLink>
                      {activeIndex === index && subNav && (
                        <Collapse
                          in={true}
                          timeout="auto"
                          unmountOnExit
                          key={`collapse-bar-${Math.random()}`}
                        >
                          <List component="div" disablePadding>
                            {renderSubMenu(subNav)}
                          </List>
                        </Collapse>
                      )}
                    </>
                  );
                }
                return null;
              }
            )
            .filter(Boolean)
        )}
      </List>
      <div>
        <hr className="mx-3 bg-white" />
        <div>
          <List className={classes.nav} style={{ textDecoration: "none" }}>
            {commonNavLink.map(
              ({ to, label, iconName, inactiveIcon, nestedChild }, index) => (
                <Fragment key={`common-nav-bar-${Math.random()}`}>
                  <NavLink
                    key={`common-nav-bar-${Math.random()}`}
                    to={to ? to : location.pathname}
                    onClick={() => {
                      setActiveIndex((prevIndex) =>
                        prevIndex === index ? -1 : index
                      );
                      setActive(null);
                        dispatch(setShowNavbar(false));
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      style={{
                        borderLeft: location.pathname.startsWith(to)
                          ? "8px solid #367BBF"
                          : "8px solid #ffffff",
                      }}
                    >
                      <ListItem
                        button
                        className={
                          location.pathname.startsWith(to)
                            ? "active-div"
                            : "inActive-div"
                        }
                      >
                        <ListItemText>
                          <div className="d-flex">
                            <span className="mr-4 ml-md-2">
                              {location.pathname.startsWith(to) ? (
                                <img src={iconName} className="sidebar_icon" />
                              ) : (
                                <img src={inactiveIcon} className="sidebar_icon" />
                              )}
                            </span>
                            <span
                              className={
                                location.pathname.startsWith(to)
                                  ? "activeBar"
                                  : "inActiveBar"
                              }
                            >
                              {label}
                            </span>{" "}
                          </div>
                        </ListItemText>
                      </ListItem>
                    </div>
                  </NavLink>
                  <div
                    className="p-3 cursor-pointer"
                    onClick={() => {
                      logout();
                    }}
                  >
                    <span className="inActiveBar">
                      <MdLogout fontSize={15} />{" "}
                      <span className="logout">Logout</span>
                    </span>
                  </div>
                </Fragment>
              )
            )}
          </List>
        </div>
      </div>
    </div>
  );

  const container = window !== undefined ? window.document.body : undefined;

  return (
    <div>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === "rtl" ? "right" : "left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown={!ShowNavBar ? true : false} implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    </div>
  );
}

export default Sidebar;
